import { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Routing from 'Vendor/Components/Routing'
import UserContextProvider from 'Vendor/Context/UserContextProvider'
import CollectionContextProvider from 'Vendor/Context/CollectionContextProvider'
import BannerContextProvider from "Vendor/Context/BannerContextProvider";
import ListingContextProvider from 'Vendor/Context/ListingContextProvider'
import CardSettingsProvider from 'Vendor/Context/CardSettingsContext'
import routes from 'Routing/AppRouting'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import UploadSystem from "./UploadSystem";
import { StoreProvider } from './Store/StoreProvider'

const App: FC = () => (
    <BannerContextProvider>
        <UserContextProvider>
            <CollectionContextProvider>
                <ListingContextProvider>
                    <CardSettingsProvider>
                        <StoreProvider>
                            <BrowserRouter>
                                <UploadSystem>
                                    <Routing routes={routes} />
                                </UploadSystem>
                            </BrowserRouter>
                        </StoreProvider>
                    </CardSettingsProvider>
                </ListingContextProvider>
            </CollectionContextProvider>
        </UserContextProvider>
    </BannerContextProvider>
)

export default App